module.exports = {"jk":{"latestVersion":"0.4.0"}}


//////////////////
// WEBPACK FOOTER
// ./src/params.json
// module id = qaNP
// module chunks = 1